import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'

export interface AppVersionInfo {
  /** Marketing version, e.g. "0.0.21" (native) or the baked package.json version (web). */
  version: string | undefined
  /** Native build number (iOS CFBundleVersion / Android versionCode); undefined on web. */
  build: string | undefined
}

// The bundle version is baked in at build time (vite.config.ts define); on
// native we prefer the real binary's version + build from the Capacitor App
// plugin so the profile shows exactly what the store/TestFlight installed.
const BUNDLE_VERSION = import.meta.env.VITE_APP_VERSION as string | undefined

export function useAppVersion(): AppVersionInfo {
  const [info, setInfo] = useState<AppVersionInfo>({
    version: BUNDLE_VERSION,
    build: undefined,
  })

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    let cancelled = false
    CapacitorApp.getInfo()
      .then(({ version, build }) => {
        if (!cancelled) setInfo({ version: version || BUNDLE_VERSION, build })
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  return info
}

export function formatAppVersion({ version, build }: AppVersionInfo): string {
  if (!version) return ''
  return build ? `Version ${version} (${build})` : `Version ${version}`
}
